class CollectionDescription extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.content = this.querySelector('[data-collection-description-content]');
    this.toggle = this.querySelector('[data-collection-description-toggle]');
    this.label = this.querySelector('[data-collection-description-label]');
    if (!this.content || !this.toggle || !this.label) return;

    this.dataset.initialized = 'true';
    this.expanded = false;
    this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded));

    this.resizeObserver = new ResizeObserver(() => this.sync());
    this.resizeObserver.observe(this.content);
    requestAnimationFrame(() => this.sync());
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  setExpanded(expanded) {
    this.expanded = expanded;
    this.classList.toggle('is-expanded', expanded);
    this.toggle.setAttribute('aria-expanded', String(expanded));
    this.label.textContent = expanded ? this.dataset.collapseLabel : this.dataset.expandLabel;
    this.content.style.maxHeight = expanded ? `${this.content.scrollHeight}px` : '';
  }

  sync() {
    if (this.expanded) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      return;
    }

    const canExpand = this.content.scrollHeight > this.content.clientHeight + 2;
    this.toggle.hidden = !canExpand;
    this.classList.toggle('can-expand', canExpand);
  }
}

if (!customElements.get('collection-description')) {
  customElements.define('collection-description', CollectionDescription);
}
